import { SrcInfoContainer } from '@nile/banyan/src/Utils/style';
import { Icon, SearchFilter, BackgroundIcon } from '@nile/components';
import {
  checkDynamicQuery,
  fetchValues,
  generateOptions,
  getAsyncOptions,
  getDefaultValue,
  getDynamicQuery,
  getKeyName,
  getMethodName
} from '@nile/projects/src/Pebbles/ProjectPages';
import { Button, Heading, Link } from '@shopify/polaris';
import { Suitcase } from '@styled-icons/fa-solid';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import shortid from 'shortid';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const InfoContainer = styled(SrcInfoContainer)`
  .Polaris-Heading {
    margin-bottom: 8px;
  }
`;

const ProjectListingHeader = (props) => {
  return (
    <>
      <InfoContainer>
        <div className="fx2 Main-Heading">
          <Heading element="h1">
            <Icon
              style={{
                width: 20,
                height: 20,
                color: '#252739',
                margin: '-5px 15px 0px 0px'
              }}
              icon={Suitcase}
            />
            All Projects
          </Heading>
        </div>
        <div className="fx fx2 jend actr">
          <div className="mr10">
            <SearchFilter
              entity="Project"
              personalization={props.personalization}
              updateCondition={props.handleConditionInput}
              currentViewConditions={props.condition}
              getDefaultValue={getDefaultValue}
              getDynamicQuery={getDynamicQuery}
              checkDynamicQuery={checkDynamicQuery}
              generateOptions={generateOptions}
              getMethodName={getMethodName}
              getKeyName={getKeyName}
              fetchValues={fetchValues}
              getAsyncOptions={getAsyncOptions}
            />
          </div>
          <Link url={`#/projects/${shortid.generate()}/new`}>
            <Button
              primary
              id="createProjectBtn"
              icon={<SVGIcon name="Add" color="#fff" />}
            >
              <FormattedMessage id="common.save" />
            </Button>
          </Link>
        </div>
      </InfoContainer>
    </>
  );
};

export default ProjectListingHeader;
